import { Injectable } from '@angular/core';
import { CartActions, MultiCartService } from '@spartacus/cart/base/core';

@Injectable({
  providedIn: 'root',
})
export class CustomMultiCartService extends MultiCartService {
  setActiveCartIdEmpty(): void {
    this.store.dispatch(new CartActions.ClearCartState());
  }
}
